import {Typography} from '@bonprix/design-system';
import {ActiveUnderlineWrapper} from './ActiveUnderlineWrapper.jsx';
import Device from '@core/scripts/components/device';
import Landmark from '@core/scripts/components/landmark-adapter';
import {useContext, useRef} from 'react';
import NavigationLayerHidden from './NavigationLayerHidden.jsx';
import {HeaderContext} from '@header/scripts/components/context/HeaderContext.jsx';

export default function NavigationItem({
    navigationItem,
    setCurrentHoveredItemId,
    currentHoveredItemId,
    isShopActive,
    delayedExecution,
}) {
    const {headerLightMode} = useContext(HeaderContext);

    const isTouchDevice = useRef(Device.isTouch() || matchMedia('(hover: none)').matches);

    const handleHoverIn = () => {
        delayedExecution(() => {
            setCurrentHoveredItemId(navigationItem.id);
        });
    };

    const handleHoverOut = () => {
        delayedExecution(() => {
            setCurrentHoveredItemId(undefined);
        });
    };

    const handleClick = (e) => {
        if (isTouchDevice.current) {
            e.preventDefault();
            setCurrentHoveredItemId(navigationItem.id);
        } else {
            const naviLmValue = `hn\\${navigationItem.id}\\\\`;
            Landmark.sendUserInterfaceLandmark({navi: naviLmValue});
        }
    };

    const itemColor = headerLightMode ? 'on-primary-high' : 'primary';
    const renderButHide = !currentHoveredItemId && navigationItem.active;
    return (
        <li onMouseEnter={handleHoverIn} onPointerLeave={handleHoverOut} className="navigation__item -level:first">
            <a href={navigationItem.url} className={'navigation__item-label -level:first'} onClick={handleClick}>
                <ActiveUnderlineWrapper
                    navigationItem={navigationItem}
                    currentHoveredItemId={currentHoveredItemId}
                    isShopActive={isShopActive}
                    lightMode={headerLightMode}
                >
                    <Typography color={itemColor} variant="bonprix-h5" component={'span'}>
                        {navigationItem.title}
                    </Typography>
                </ActiveUnderlineWrapper>
            </a>
            {renderButHide && <NavigationLayerHidden secondLevelNavigationItems={navigationItem.subNavigationItems} />}
        </li>
    );
}
